
import SequenceSettingsService from './SequenceSettingsService';

export { default } from './SequenceSettingsService';
export const sequenceSettingsService = new SequenceSettingsService();